import { IAd } from '../ad/domain/ad';
import { IUrlParameterMap } from '../ad/domain/url-parameters';
import { IAdApi } from './declarations/ad-api';
import { ICustomEvent } from '../ad/tracking';

export class AdApi implements IAdApi {
    parameters: IUrlParameterMap;
    constructor(private ad: IAd) {
        this.parameters = ad.parameters;
    }

    trackCustomEvent(eventData: ICustomEvent): void {
        this.ad.tracking.trackCustomEvent(eventData);
    }

    trackCustomProgressEvent(eventData: ICustomEvent): void {
        this.ad.tracking.trackCustomProgressEvent(eventData);
    }
}
